import React, {Component} from 'react';
import {allAvailableValidators} from "lib/passwordValidator";
import 'assets/sass/common/InputPassword.scss';

export class InputPassword extends Component {
    constructor(props) {
        super(props);
        this.validators = this._defineValidators();

        this.state = {
            peeking: false,
            capsActivated: false,
            isFilled: false,
            hasError: false,
            minLength: false,
            hasLowerAndUppercase: false,
            hasNumbers: false,
        };

        this.handleBlur = this.handleBlur.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.togglePeak = this.togglePeak.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    _defineValidators() {
        let validators = [];
        Object.keys(allAvailableValidators).forEach(validatorName => {
            const validationValue = this.props[validatorName];
            if (validationValue) {
                const validatorClass = allAvailableValidators[validatorName];
                validators.push(new validatorClass(validationValue));
            }
        });

        return validators;
    }

    validate(password) {
        if (!this.props.withValidation) return;

        let newState = {};
        this.validators.forEach(validator => {
            newState[validator.name()] = validator.isValid(password);
        });

        this.setState(newState, this.checkValidity.bind(this));
    }

    checkValidity() {
        let isValid = this.isValid();
        this.props.onValidationChange(isValid);
        this.setState({hasError: !isValid})
    }

    isValid() {
        return this.state.minLength && this.state.hasLowerAndUppercase && this.state.hasNumbers;
    }

    handleKeyUp(event) {
        this.setState({capsActivated: event.getModifierState('CapsLock')});
    }

    handleFocus() {
        this.setState({hasError: false, capsActivated: false});
    }

    handleBlur(event) {
        const value = event.target.value;
        const isFilled = value.length !== 0;
        this.setState({isFilled: isFilled, capsActivated: false});

        if (isFilled) {
            this.validate(value);
        }
    }

    togglePeak() {
        const beforeState = this.state.peeking;
        this.setState({peeking: !beforeState});
    }

    handleChange(event) {
        const value = event.target.value;
        this.validate(value);
        this.props.onChange(event);
    }

    renderSecurityInfo() {
        if (this.props.withValidation) {
            return <SecurityInfo minLength={this.state.minLength} hasLowerAndUppercase={this.state.hasLowerAndUppercase}
                                 hasNumbers={this.state.hasNumbers}/>
        }
    }

    inputClasses() {
        return 'input-password ' +
            (this.state.isFilled ? ' filled' : '') +
            ((this.state.hasError || this.props.errorMessage) ? ' error' : '') +
            (this.state.capsActivated ? ' caps' : '') +
            (this.state.peeking ? ' peeking' : '')
    }

    render() {
        return (
            <div className={this.inputClasses()}>
                <input type={(this.state.peeking ? 'text' : 'password')} name={this.props.name || "password"}
                       placeholder={this.props.placeholder}
                       onChange={this.handleChange} onBlur={this.handleBlur}
                       onFocus={this.handleFocus} onKeyUp={this.handleKeyUp}
                       autoComplete="current-password"
                />
                <div className="input-label">{this.props.label}</div>
                <div className="input-password-alert">Bloqueo de mayúsculas activado</div>
                <div className="input-password-error">{this.props.errorMessage || "Password inválida"}</div>
                <div className="input-password-peek" onClick={this.togglePeak}></div>
                <div className="input-password-icon-valid"></div>
                {this.renderSecurityInfo()}
            </div>
        );
    }
}

InputPassword.defaultProps = {
    withValidation: true,
    minLength: 8,
    hasLowerAndUppercase: true,
    hasNumbers: true,
    onValidationChange: function (isValid) {
    }
};


class SecurityInfo extends React.Component {
    indicatorsClasses() {
        return 'input-password-secure ' +
            (this.props.minLength ? ' secure-length' : '') +
            (this.props.hasNumbers ? ' secure-number' : '') +
            (this.props.hasLowerAndUppercase ? ' secure-mayus' : '')
    }

    securityLevel() {
        return [
            this.props.minLength,
            this.props.hasLowerAndUppercase,
            this.props.hasNumbers
        ].filter(element => element === true).length;
    }

    securityLevelName() {
        const levelsName = {
            1: 'bajo',
            2: 'medio',
            3: 'alto'
        };

        return levelsName[this.securityLevel()];
    }

    render() {
        return (
            <div className={this.indicatorsClasses()}>
                <div className="secure-list">
                    <h5>Tu contraseña debe contener:</h5>
                    <ul>
                        <li className="secure-length">
                            <div className="icon-secure"></div>
                            <div className="icon-insecure"></div>
                            <span>8 o más caracteres</span>
                        </li>
                        <li className="secure-mayus">
                            <div className="icon-secure"></div>
                            <div className="icon-insecure"></div>
                            <span>Mayúsculas y minúsculas</span>
                        </li>
                        <li className="secure-number">
                            <div className="icon-secure"></div>
                            <div className="icon-insecure"></div>
                            <span>Al menos un número</span>
                        </li>
                    </ul>
                    <span>Además se validará que la contraseña no haya aparecido luego de una violación de datos o sea muy sencilla.</span>
                </div>
                <div className="secure-bar">
                    <h5>Nivel de seguridad: {this.securityLevelName()}</h5>
                    <div className="secure-bar-main">
                        <div className="bar-insecure"></div>
                        <div className="bar-list"></div>
                        <div className="bar-secure"></div>
                    </div>
                </div>
            </div>
        )
    }
}